import loadable from 'react-loadable';

import {Loading} from '../common';

export const AdminPage = loadable({
    delay: 300,
    loader: () => import('./AdminPage'),
    loading: Loading
});

export const AdminContainer = loadable({
    delay: 300,
    loader: () => import('./AdminContainer'),
    loading: Loading
});

export const BirthdaysTab = loadable({
    delay: 300,
    loader: () => import('./birthdays/BirthdaysTab'),
    loading: Loading
});

export const ConfigTab = loadable({
    delay: 300,
    loader: () => import('./config/ConfigTab'),
    loading: Loading
});

export const EventsTab = loadable({
    delay: 300,
    loader: () => import('./events/EventsTab'),
    loading: Loading
});

export const GroceriesTab = loadable({
    delay: 300,
    loader: () => import('./groceries/GroceriesTab'),
    loading: Loading
});

export const MessagesTab = loadable({
    delay: 300,
    loader: () => import('./messages/MessagesTab'),
    loading: Loading
});

export const OfficesTab = loadable({
    delay: 300,
    loader: () => import('./offices/OfficesTab'),
    loading: Loading
});

export const UsersTab = loadable({
    delay: 300,
    loader: () => import('./users/UsersTab'),
    loading: Loading
});
export const SystemAnnouncementsTab = loadable({
    delay: 300,
    loader: () => import('./systemAnnouncements/SystemAnnouncementsTab'),
    loading: Loading
});

export const VideosTab = loadable({
    delay: 300,
    loader: () => import('./videos/VideosTab'),
    loading: Loading
});


// WEBPACK FOOTER //
// ./src/components/admin/index.js